var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-category section-full"},[_c('grid-view',{attrs:{"type":'staff',"items":_vm.staffs,"show-staff-avatar":_vm.displayStaffAvatar},on:{"pickItem":_vm.pickStaff}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }